import styled, { css } from 'styled-components'
import { BaseColor, Color, ColorShade, elevation, rem, themeColor, transitions } from '~theme'

export const Input = styled.input`
  appearance: none;
  display: inline-block;
  border-radius: 9999px;
  background: ${themeColor(BaseColor.shade_50)};
  border: 1px solid transparent;
  color: ${themeColor(Color.primary, ColorShade.foreground)};
  --ring-color: transparent;
  outline: 1px solid var(--ring-color);
  outline-offset: 0;
  margin: 0;
  ${transitions(['background-color', 'color', 'border-color', 'box-shadow'])};
  cursor: pointer;

  &:hover {
    background: ${themeColor(BaseColor.shade_60)};

    &:checked {
      background: ${themeColor(Color.primary, ColorShade.semiStrong)};
    }
  }
  &:focus-visible {
    background: ${themeColor(BaseColor.shade_50)};
    --ring-color: ${themeColor(BaseColor.shade_50)};

    &:checked {
      border-color: ${themeColor(BaseColor.shade_0)};
      --ring-color: ${themeColor(Color.primary)};
    }
  }
  &:checked {
    background: ${themeColor(Color.primary)};
    border-color: transparent;
    color: ${themeColor(Color.primary, ColorShade.foreground)};

    &::before {
      left: ${rem(30)};
    }
  }
  &:disabled {
    background-color: transparent;
    border-color: ${themeColor(BaseColor.shade_30)};
    color: ${themeColor(BaseColor.shade_30)};

    &::before {
      box-shadow: none;
    }
    &:checked {
      background-color: ${themeColor(BaseColor.shade_30)};
      color: ${themeColor(BaseColor.shade_50)};
    }
  }
  &::before {
    content: '';
    display: block;
    position: absolute;
    border-radius: 100%;
    background-color: currentColor;
    ${transitions(['left'])};
    ${elevation(4)}
    box-shadow: 0px 1px 2px rgba(0, 0, 0, 0.1), 0px 1px 3px 1px rgba(0, 0, 0, 0.05);
  }
`

const largeSize = css`
  ${Input} {
    width: ${rem(48)};
    height: ${rem(24)};

    &::before {
      top: ${rem(6)};
      left: ${rem(6)};
      height: ${rem(12)};
      width: ${rem(12)};
    }
    &:checked {
      &::before {
        left: ${rem(30)};
      }
    }
  }
`

const smallSize = css`
  ${Input} {
    width: ${rem(32)};
    height: ${rem(16)};

    &::before {
      top: ${rem(4)};
      left: ${rem(4)};
      height: ${rem(8)};
      width: ${rem(8)};
    }
    &:checked {
      &::before {
        left: ${rem(20)};
      }
    }
  }
`

interface ContainerProps {
  size: 'large' | 'small'
}

export const Container = styled.label<ContainerProps>`
  display: flex;
  align-items: center;
  position: relative;
  ${props => (props.size === 'large' ? largeSize : smallSize)};

  &:hover {
    ${Input} {
      border-color: ${themeColor(BaseColor.shade_70)};
      &:checked {
        border-color: transparent;

        &:focus-visible {
          border-color: ${themeColor(Color.primary)};
        }
      }
      &:disabled {
        border-color: ${themeColor(BaseColor.shade_30)};
      }
    }
  }
`
